<template>
  <div>
    <Title :pages="[{ icon: 'cog', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <!-- Modal -->
      <Modal
        v-if="create_access"
        :button_name="'Crear ' + modal_title"
        :modal_title="modal_title"
        :page_title="page_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :editItem="mainItem"
      />

      <!-- Filtros -->
      <v-card class="mb-4" v-if="list_access">
        <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
          <div class="col-md-12">
            <div class="col-md-12" style="background: white">
              <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
              <v-divider class="mt-0"></v-divider>

              <div class="row pt-2">
                <div class="col-md-4">
                  <v-combobox v-model="filters.product" density="comfortable" item-title="name" item-value="id" :items="products" label="Producto" autocomplete="off" clearable></v-combobox>
                </div>
                <div class="col-md-4">
                  <v-combobox v-model="filters.client" density="comfortable" item-title="name" item-value="id" :items="clients" label="Cliente" autocomplete="off" clearable></v-combobox>
                </div>
                <div class="col-md-4">
                  <v-combobox v-model="filters.almacen" density="comfortable" item-title="name" item-value="id" :items="almacenes" label="Almacén" autocomplete="off" clearable></v-combobox>
                </div>

                <div class="col-md-12 pt-2" style="display: flex; justify-content: end">
                  <v-btn color="info" class="" @click="loadList(service)" prepend-icon="mdi-magnify">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <!-- Tabla -->
      <v-card v-if="list_access">
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col>
              <span>{{ page_title }}</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando...">
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.almacen ? item.almacen.name : "-" }}</td>
              <td>{{ item.product ? item.product.name : "-" }}</td>
              <td>{{ item.client ? item.client.name : "-" }}</td>
              <td>{{ item.priority }}</td>
              <td>
                <v-chip :color="item.is_mandatory ? 'orange' : 'blue'" size="small">
                  {{ item.is_mandatory ? "Obligatoria" : "Flexible" }}
                </v-chip>
              </td>
              <td>
                <v-chip :color="item.is_active ? 'green' : 'red'" size="small">
                  {{ item.is_active ? "Activa" : "Inactiva" }}
                </v-chip>
              </td>
              <td class="text-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="update_access" v-bind="props" small color="blue" class="mr-2" v-on:click="editItem(item)" size="small">mdi-pencil</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="blue" class="mr-2" v-on:click="viewItem(item)" size="small">mdi-eye</v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="delete_access" v-bind="props" small color="red" class="mr-2" v-on:click="deleteItem(item)" size="small">mdi-delete</v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" :loading="loadingSubmit" />
    </v-container>
  </div>
</template>

<script>
import { storageRuleService } from "@/libs/ws/storageRuleService";
import { productoService } from "@/libs/ws/productoService";
import { clientService } from "@/libs/ws/clientService";
import { almacenService } from "@/libs/ws/almacenService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import Modal from "./Modal.vue";

export default {
  components: { Modal },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      service: storageRuleService,
      page_title: "Reglas de Guardado",
      modal_title: "Regla de Guardado",

      headers: [
        { title: "Nombre", align: "left", sortable: true, key: "name" },
        { title: "Almacén", align: "left", sortable: true, key: "almacen.name" },
        { title: "Producto", align: "left", sortable: true, key: "product.name" },
        { title: "Cliente", align: "left", sortable: true, key: "client.name" },
        { title: "Prioridad", align: "left", sortable: true, key: "priority" },
        { title: "Tipo", align: "left", sortable: true, key: "is_mandatory" },
        { title: "Estado", align: "left", sortable: true, key: "is_active" },
        { title: "Acciones", align: "center", sortable: false, key: "actions" },
      ],

      filters: {
        product: null,
        client: null,
        almacen: null,
      },

      // Listas para filtros
      products: [],
      clients: [],
      almacenes: [],
    };
  },

  mounted() {
    this.loadList(this.service);
    this.loadProducts();
    this.loadClients();
    this.loadAlmacenes();
  },

  methods: {
    getFilterParams() {
      let params = {};

      if (this.filters.product && this.filters.product.id) {
        params.product = { id: this.filters.product.id };
      }

      if (this.filters.client && this.filters.client.id) {
        params.client = { id: this.filters.client.id };
      }

      if (this.filters.almacen && this.filters.almacen.id) {
        params.almacen = { id: this.filters.almacen.id };
      }

      return params;
    },

    loadProducts() {
      productoService.filter({}).then((response) => {
        this.products = response.result.list;
      });
    },

    loadClients() {
      clientService.filter({}).then((response) => {
        this.clients = response.result.list;
      });
    },

    loadAlmacenes() {
      almacenService.filter({}).then((response) => {
        this.almacenes = response.result.list;
      });
    },
  },
};
</script>
